import api from '@/api'

const { $billing, $student } = api;

export const { $invoice } = $billing;
export const { $invoices } = $student;
